/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const knownCustomerNumberRemoveBodyExpectedCustomerVersionExclusiveMin = 0;
export const knownCustomerNumberRemoveBodyExpectedCustomerVersionMax = 9007199254740991;

export const KnownCustomerNumberRemoveBody = zod.object({
  expectedCustomerVersion: zod
    .int()
    .gt(knownCustomerNumberRemoveBodyExpectedCustomerVersionExclusiveMin)
    .max(knownCustomerNumberRemoveBodyExpectedCustomerVersionMax),
});

export type KnownCustomerNumberRemoveBody = zod.input<typeof KnownCustomerNumberRemoveBody>;
export type KnownCustomerNumberRemoveBodyOutput = zod.output<typeof KnownCustomerNumberRemoveBody>;
